/**
 * 地图
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";
import TMap from "./tmap";

class Map extends Component {
  constructor(props, context) {
    super(props, context);
    this.map = new TMap({
      draggable: this.props.markerDraggable,
      onMarkerChange: (position, addressComponents) => {
        this.props.onMarkerChange(position, addressComponents);
      },
      onLoaded: () => {
        this.mapLoaded = true;
        this.cached.forEach(args => args[0].call(this.map, ...args[1]));
      },
      options: props.options || {},
    });
    this.cached = [];
    this.mapLoaded = false;
    this.handlePropsChangeDebounced = debounce(this.handlePropsChange.bind(this), props.propsDebounceWait);
    this.onPageScroll = this.onPageScroll.bind(this);
    this.onPageResize = this.onPageResize.bind(this);
  }
  init() {
    const { lng, lat, city, district } = this.props;
    this.map.load({ lng, lat, city, district });
  }

  componentDidMount() {
    if (this.props.lazyLoad) {
      this.handleLazyLoad();
      window.addEventListener("scroll", this.onPageScroll);
      window.addEventListener("resize", this.onPageResize);
    } else {
      this.init();
    }
  }

  componentWillReceiveProps(nextProps) {
    this.handlePropsChangeDebounced(nextProps, this.props);
    if (nextProps.propsDebounceWait !== this.props.propsDebounceWait) {
      this.handlePropsChangeDebounced.cancel();
      this.handlePropsChangeDebounced = debounce(this.handlePropsChange.bind(this), nextProps.propsDebounceWait);
    }
  }

  componentWillUnmount() {
    if (this.map && this.map.destroy) {
      this.map.destroy();
    }
    this.map = undefined;
    if (typeof window !== "undefined" && window.removeEventListener) {
      window.removeEventListener("scroll", this.onPageScroll);
      window.removeEventListener("resize", this.onPageResize);
    }
  }

  onPageScroll(e) {
    this.handleLazyLoad();
  }

  onPageResize(e) {
    this.handleLazyLoad();
  }

  handleLazyLoad() {
    const node = this.containerNode;
    const crossed = this.crossed;
    if (crossed || !node) return;

    const doc = document.documentElement;
    const rect = node.getBoundingClientRect();
    const clientHeight = window.innerHeight || doc.clientHeight;

    const cross =
      Math.min(doc.scrollTop + rect.bottom, doc.scrollTop + clientHeight) -
      Math.max(doc.scrollTop + rect.top, doc.scrollTop);

    if (cross >= 0) {
      this.crossed = true;
      window.removeEventListener("scroll", this.onPageScroll);
      window.removeEventListener("resize", this.onPageResize);
      this.init();
    }
  }

  /* 确保地图已加载再执行 */
  ensureMap(fn, ...args) {
    if (!this.mapLoaded) {
      this.cached.push([fn, ...args]);
    } else {
      fn.call(this.map, ...args);
    }
  }

  handlePropsChange(nextProps, props) {
    const { lng, lat, city, district, street, block } = nextProps;
    if (lng && lat && lng !== props.lng && lat !== props.lat) {
      this.ensureMap(this.map.setPos, { lat, lng });
    } else if (district !== props.district) {
      if (props.street || props.block) {
        // 先填写地址再切换区的情况
        this.ensureMap(this.map.setAddress, { city, district, street, block });
      } else {
        this.ensureMap(this.map.setDistrict, city, district);
      }
    } else if (city !== props.city) {
      this.ensureMap(this.map.setCity, nextProps.city);
    } else if (street !== props.street || block !== props.block) {
      this.ensureMap(this.map.setAddress, { city, district, street, block });
    }
  }

  render() {
    return (
      <div
        ref={node => (this.containerNode = node)}
        style={{ height: 250, overflow: "hidden", ...this.props.style }}
        id={this.map.mapId}
        data-amap-dom={true}
      />
    );
  }
}

Map.defaultProps = {
  city: "",
  district: "",
  street: "",
  block: "",
  lng: null,
  lat: null,
  markerDraggable: false,
  onMarkerChange: (pos, geocode) => {
    // geocode 包含 province, city, district
    // console.log(pos, geocode)
  },
  propsDebounceWait: 400,
  style: {},
  lazyLoad: false,
};

Map.propTypes = {
  city: PropTypes.string,
  district: PropTypes.string,
  // street: PropTypes.string,
  // block: PropTypes.string,
  lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  markerDraggable: PropTypes.bool, // 是否可拖动
  onMarkerChange: PropTypes.func,
  propsDebounceWait: PropTypes.number,
  style: PropTypes.object,
  lazyLoad: PropTypes.bool,
};

export default Map;

require("./index.less");
require("./index.less");